import React, { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import { authAPI } from "../../api";
import ChickenLogo from "../ChickenLogo";
import "./Auth.css";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      await authAPI.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Une erreur est survenue. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <ChickenLogo size={64} className="auth-logo" />
          <h1>Mot de passe oublié</h1>
          <p>Recevez un lien pour choisir un nouveau mot de passe</p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        {sent ? (
          <div className="auth-success">
            <MailCheck size={40} strokeWidth={1.75} />
            <p>
              Si un compte existe avec l'adresse <strong>{email}</strong>, un email contenant
              un lien de réinitialisation vient de lui être envoyé.
            </p>
            <p className="auth-success-hint">
              Pensez à vérifier vos courriers indésirables si vous ne le voyez pas arriver.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="votre@email.com"
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg"
              disabled={loading}
              style={{ width: "100%" }}
            >
              {loading ? "Envoi..." : "Envoyer le lien de réinitialisation"}
            </button>
          </form>
        )}

        <div className="auth-footer">
          <p>
            <Link to="/login" className="auth-link">
              Retour à la connexion
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
